<div class="row container">
    <div class="faq-container">
        <p class="faq-text pt-3">{{programDisplayData?.termsAndConditions?.forMoreInfo}}
            <a (click)="redirectToFAQ()" class="links__action__default faq" tabindex="0">{{programDisplayData?.termsAndConditions?.faq}}</a>
            and <span (click)="openTerms(userSubscriptionDetails, userInfo)" (keydown.enter)="openTerms(userSubscriptionDetails, userInfo)" class="links__action__default faq"
                      role="link"
                      tabindex="0">
                    {{programDisplayData?.termsAndConditions?.termsNconditions}}</span>
        </p>
    </div>
</div>

